'use strict';

var _ = require('underscore');
var Collection = require('js/lib/collection');
var Search = require('js/models/search');
var Members = require('js/collections/members');
var Communities = require('js/collections/communities');
var config = require('js/config');

/**
 * Searches
 * @exports Searches
 * @constructor
 * @alias module:collections/searches
 */
var Searches = Collection.extend({
  url: config.build.apiPath + '/api/sitesearch',

  // Pagination type
  paginationType: Collection.PAGINATION_TYPES.START_LIMIT,

  // Use search model
  model: Search,

  // Data cache
  dataCacheMap: {
    'users': Members,
    'groups': Communities,
  }
});


/**
 * Parse server search results
 * @param response
 * @returns {*}
 */
Searches.prototype.parse = function(response, options) {
  var result;
  options = options || {};

  // In the case we have no results returned
  if (!response.result && !response.hits && !response.posts) {
    this.total = 0;
    this.facets = [];

    return [];
  }

  // Ensure data cache
  this.ensureDataCache(response, this.dataCacheMap, options.accumulate);

  // Response is already formatted correctly, yay!
  if (response.hits || response.posts) {
    result = response;
  }
  // Parse a potential json string block
  else if (typeof response.result === 'string') {
    result = JSON.parse(response.result);
  }
  // extract from result property
  else {
    result = response.result;
  }

  if (result['raw-string']) {
    result = JSON.parse(result['raw-string']);
  }
  if (_.has(result, 'recommended') && result.recommended.hits && result.recommended.hits.hits) {
    this.hasRecommended = !!result.recommended.hits.hits.length;
    if (result.hits.hits) {
      const alteredRecResults = result.recommended.hits.hits.map(recPost => {
        recPost._source.isRecommended = true;
        return recPost;
      });
      result.hits.hits = [...alteredRecResults, ...result.hits.hits];
    }
  }
  if (result.hits) {
    // Account for different ES response format as 'hits'
    // TODO [BG-2141] tagspage entities endpoint to be moved to own its model, see search.js comment
    /***********************************/
    if(!result.hits.hits) {
      this.entity = this.parseEntity(response);
      return this.parseCollection(this.entity.hits, options);
    }
    /***********************************/

    // Store total hits
    this.total = result.hits.total;
    this.facets = result.facets;

    return this.parseCollection(result.hits.hits, options);
  } else if (result.posts) {
    this.total = result.facets.groups.total;
    this.facets = result.facets;

    return this.parseCollection(result.posts, options);
  }

  // Otherwise extract 'docs'
  // Store total hits
  this.total = result.docs.length;
  this.facets = [];

  return this.parseCollection(result.docs, options);
};

/**
 * Fetch results which are 'more like this'
 */
Searches.prototype.fetchMoreLikeThis = function(postId, groupCode, options) {
  const moreLikeThisUrl = 'more-like-this2';

  return this.fetch(_.extend({
    url: `${this.url}/${moreLikeThisUrl}`,
    data: {
      groupCode: groupCode,
      postId: postId,
    }
  }, options));
};


/**
 * Search communities
 */
Searches.prototype.fetchCommunitySearch = function(key, options) {
  return this.desc('key', key).desc('es', true).fetch(_.extend({
    url: config.build.apiPath + '/api/communities/search'
  }, options));
};

/**
 * Use search to fetch single community into the collection via groupCode
 */
Searches.prototype.fetchCommunityFromSearch = function(groupCode, options) {
  return this.desc('groupCode', groupCode).fetch(_.extend({
    url: config.build.apiPath + '/api/communities/search/get'
  }, options));
};

module.exports = Searches;



// WEBPACK FOOTER //
// ./app/assets/js/collections/searches.js